import {Template, TemplateItemParams, TemplateType} from '@dv5/domain'
import React, {FC, useState} from 'react'
import {Button} from "../inputs/Button"
import {templateService} from "../service/templateService"
import {TemplateItem} from "./TemplateItem"
import {TemplateDataDialog} from "./TemplateDataDialog"

interface Props {
    templates: Template[]
    isLoading: boolean
    type: TemplateType
    mode: 'selection' | 'manager'
    onSelect: (template: Template, params: TemplateItemParams) => void
    onDelete: (templateId: string) => void
    onRename: (templateId: string, newTitle: string) => void
    onCancel: () => void
    onTemplateUpdated?: (template: Template) => void
    selectedTemplateId?: string
}

export const TemplateListContent: FC<Props> = ({
                                                    templates,
                                                    isLoading,
                                                    mode,
                                                    type,
                                                    onSelect,
                                                    onDelete,
                                                    onRename,
                                                    onCancel,
                                                    onTemplateUpdated,
                                                    selectedTemplateId,
                                                }) => {
    const [viewDetailsTemplate, setViewDetailsTemplate] = useState<Template | null>(null)

    return (
        <>
            <div className="template-list-container">
                {isLoading ? (
                    <div className="loading-message">Loading templates...</div>
                ) : templates.length === 0 ? (
                    <div className="empty-message">No "{templateService.getTitle(type)}" templates available</div>
                ) : (
                    <div className="template-list">
                        {templates.map((template) => (
                            <TemplateItem
                                key={template.id}
                                template={template}
                                mode={mode}
                                onSelect={onSelect}
                                onDelete={onDelete}
                                onRename={onRename}
                                onViewDetails={setViewDetailsTemplate}
                                isSelected={selectedTemplateId === template.id}
                            />
                        ))}
                    </div>
                )}
            </div>
            {mode !== 'manager' && <div className="buttons">
                <Button title="Cancel" onClick={onCancel} className="cancel-dialog-button"/>
            </div>}
            {viewDetailsTemplate && (
                <TemplateDataDialog
                    template={viewDetailsTemplate}
                    onClose={() => setViewDetailsTemplate(null)}
                    onTemplateUpdated={(updated) => {
                        setViewDetailsTemplate(updated)
                        onTemplateUpdated?.(updated)
                    }}
                />
            )}
        </>
    )
}
